import React from 'react'
import { IonLabel, IonToolbar, IonSegment, IonSegmentButton } from '@ionic/react'
import { setSelectedOption } from '../store/initialAssessment.actions'
import { InitialAssessmentConstants } from '../store/initialAssessment.constants'
import { useDispatch, useSelector } from 'react-redux'
import { getInitialAssessmentSelector } from '../selectors'
import { useTranslation } from 'react-i18next'

const InitialAssessmentMobile = () => {
  const { selectedOption } = useSelector(getInitialAssessmentSelector)
  const dispatch = useDispatch()
  const { t } = useTranslation()

  return (
    <IonToolbar color='light'>
      <IonSegment
        color='dark'
        value={selectedOption}
        className='toolbar-segment-margin segment-bottom-padding w-100'
        onIonChange={(e: any) => {
          dispatch(setSelectedOption(e.target?.value))
        }}>
        <IonSegmentButton data-testid='Neuro' value={InitialAssessmentConstants.NEURO}>
          <IonLabel>{t('neuro.Neuro')}</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton data-testid='Airway' value={InitialAssessmentConstants.AIRWAY}>
          <IonLabel>{t('initialAssessmentAirway.Airway')}</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton data-testid='Respiratory' value={InitialAssessmentConstants.RESPIRATORY}>
          <IonLabel>{t('respiratory.Respiratory')}</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton data-testid='Cardio' value={InitialAssessmentConstants.CARDIO}>
          <IonLabel>{t('cardio.Cardio')}</IonLabel>
        </IonSegmentButton>
      </IonSegment>
    </IonToolbar>
  )
}

export default InitialAssessmentMobile
